export const FORM_ITEM_LAYOUT = {
  labelcol: { span: 6, offset: 0 },
  wrappercol: { span: 17 },
};
